import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from "vue";

import { OfficeResponse } from "@/types";
import { SnakeToCamelCaseObj } from "@/types/utils/CaseTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'OfficeAddress',
  props: {
    office: null
  },
  setup(__props: any) {

const props = __props as {
  office: SnakeToCamelCaseObj<OfficeResponse>;
};



const { office } = toRefs(props);

const getOfficeLabel = (o: SnakeToCamelCaseObj<OfficeResponse>): string => {
  let officeLabel = "";
  if (o.type === "main" || !o.type) {
    officeLabel = "Main Office";
    if (o.positionSummary) {
      officeLabel += " - " + o.positionSummary;
    }
    return officeLabel;
  }
  const firstPartOfLabel = o.type.charAt(0).toUpperCase() + o.type.slice(1);
  return `${firstPartOfLabel} Office (${o.city}, ${o.state})`;
};

return { __sfc: true,props, office, getOfficeLabel }
}

})